module.exports = __webpack_public_path__ + "img/personal-data-icon.26e89975.svg";